import { getTemplateCategory } from 'templates/api';
import { TOP_TEMPLATE_ITEM } from 'templates/constants';
import { TemplateCategoryModel } from 'templates/types';
import { createWithEqualityFn } from 'zustand/traditional';

type CategoryState = {
  category: TemplateCategoryModel | null;
  isLoading: boolean;
  fetchCategoryData: (category: string, subCategory: string, segments?: string[]) => Promise<void>;
};

const useCategoryDataStore = createWithEqualityFn<CategoryState>(set => ({
  category: null,
  isLoading: true,
  fetchCategoryData: async (category, subCategory, segments = []) => {
    set({ isLoading: true });
    let categoryData;

    const headers = {
      segments,
    };

    try {
      categoryData = await getTemplateCategory(category, subCategory, headers);
    } catch (err) {
      categoryData = { data: TOP_TEMPLATE_ITEM[0] };
    }

    set({
      category: categoryData.data,
      isLoading: false,
    });
  },
}));

export default useCategoryDataStore;
